export default __webpack_public_path__ + "static/media/fullstack.8fd53fb8.svg";